import { render } from "./QuotesView.vue?vue&type=template&id=25a1623a"
import script from "./QuotesView.vue?vue&type=script&lang=js"
export * from "./QuotesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__